// React imports.
import React from "react";


// App imports.
import Assessment3Sup1TableRow from "./Assessment3Sup1TableRow";

const Assessment3Sup1Table = ({ state }) => (
    <div>
        
        <br />
        <div className="vendorsReportedGrid">
            <div className="header">Main Heating Fuel	</div>
		
            {state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholds === true &&		
            <div className="header">Total # of Assisted Households	</div>
            }		
            {state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholdsServedByVendorsSelected === true &&		
            <div className="header"># of Households Represented by Vendors Selected for Data Collection	</div>
            }		
            {state.Assessment3Steps[state.CurrentAssessementStepIndex].showPercentHouseholdsServedByVendorsSelected === true &&		
            <div className="header">% of Total Represented by Vendors Selected for Data Collection	</div>
            }		
            {state.Assessment3Steps[state.CurrentAssessementStepIndex].showHouseholdsServedByVendorsSelectedStatus === true &&		
            <div className="header">Vendors Selected Percent Status	</div>
            }
      
            {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels === true
                || state.Assessment3Steps[state.CurrentAssessementStepIndex].currentFuelName === state.Assessment3FuelTypesStatus.Electric.name)
                &&
                <Assessment3Sup1TableRow rowClass={state.getGridRowClass(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels, state.Assessment3FuelTypesStatus.Electric.name )}  state={state} fuel={state.Assessment3FuelTypesStatus.Electric} />
            }
            {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels === true
                || state.Assessment3Steps[state.CurrentAssessementStepIndex].currentFuelName === state.Assessment3FuelTypesStatus.NaturalGas.name)
                &&
                <Assessment3Sup1TableRow rowClass={state.getGridRowClass(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels, state.Assessment3FuelTypesStatus.NaturalGas.name )}  state={state} fuel={state.Assessment3FuelTypesStatus.NaturalGas} />
            }
            {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels === true
                || state.Assessment3Steps[state.CurrentAssessementStepIndex].currentFuelName === state.Assessment3FuelTypesStatus.FuelOil.name)
                &&
                <Assessment3Sup1TableRow rowClass={state.getGridRowClass(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels, state.Assessment3FuelTypesStatus.FuelOil.name )}  state={state} fuel={state.Assessment3FuelTypesStatus.FuelOil} />
            }
            {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels === true
                || state.Assessment3Steps[state.CurrentAssessementStepIndex].currentFuelName === state.Assessment3FuelTypesStatus.Propane.name)
                &&
                <Assessment3Sup1TableRow rowClass={state.getGridRowClass(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels, state.Assessment3FuelTypesStatus.Propane.name )}  state={state} fuel={state.Assessment3FuelTypesStatus.Propane} />
            }
        </div>
    </div>
);

export default Assessment3Sup1Table;
